import {ILogService} from "angular";

export class ChatService {
    public APPLICATION_MESSAGES_ROOT_PATH = "application-messages";
    public ASSESSMENT_MESSAGES_ROOT_PATH = "assessment-messages";
    public GROUP_CHANNEL_NAME = "group";

    /* @ngInject */
    constructor(private $log: ILogService,
                private base64: any) {
    }

    public generateChannelName(channel: string) {
        return this.base64.urlencode(channel);
    }

    public generateChannelReadByName(channel: string) {
        return this.generateChannelName(channel) + "-readBy";
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/main/client/app/shared/chat/chat.service.ts